// extracted by mini-css-extract-plugin
export default {"notesInput":"Style_notesInput__RfOUI","subText":"Style_subText__MI70O"};